import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import DoubleColorHeadline from 'components/DoubleColorHeadline/DoubleColorHeadline';
import ParallaxTitleComponent from 'components/ParallaxTitle/ParallaxTitle';
import { mediaDesktop } from 'utils/styles/responsive';
import { layout } from 'utils/styles/theme';

interface JoinUsPageWrapperProps {
  isFirstHero?: boolean;
}

const columns = layout.columns.max;

export const JoinUsPageWrapper = styled(motion.div)<JoinUsPageWrapperProps>`
  ${({ isFirstHero }) => `padding: ${isFirstHero ? '0' : '277px'} 0 120px`};

  display: grid;
  grid-template-columns:
    [out-left] 16px
    repeat(${columns}, [content] minmax(0px, 1fr))
    [out-right] 16px;

  ${({ isFirstHero }) =>
    mediaDesktop(`
    grid-template-columns: [out-left] 92px repeat(${columns}, [content] minmax(0px, 1fr)) [out-right] 92px;
    grid-column-gap: 32px;
    padding: ${isFirstHero ? '0' : '329px'} 0 240px;
  `)}
`;

export const IndexPageHeadline = styled(DoubleColorHeadline)`
  grid-column: 2 / -2;
  margin-bottom: 40px;

  ${mediaDesktop(css`
    margin-bottom: 136px;
  `)}
`;

export const ParallaxTitle = styled(ParallaxTitleComponent)`
  height: 100%;

  grid-column: 1 / -1;
  margin: 120px 0;

  ${mediaDesktop(css`
    margin: 240px 0;
  `)}
`;
